import { render } from "./key-ratio.vue?vue&type=template&id=a109b9d2&scoped=true"
import script from "./key-ratio.vue?vue&type=script&lang=js"
export * from "./key-ratio.vue?vue&type=script&lang=js"

import "./key-ratio.vue?vue&type=style&index=0&id=a109b9d2&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a109b9d2"]])

export default __exports__